import React, { useState, useEffect, useRef } from "react";
import { Search, Bell, ChevronDown, User, School, Book } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./AdminLayout.css";

const AdminTopNav = ({ user, handleLogout }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [showResults, setShowResults] = useState(false);
    const navigate = useNavigate();
    const searchRef = useRef(null);

    const mockResults = {
        schools: [
            { id: 1, name: "Applied Life Sciences", code: "ALS-01" },
            { id: 2, name: "Business Innovation", code: "BI-05" },
        ],
        users: [
            { id: 101, name: "Dr. Sarah Chen", role: "Faculty" },
            { id: 102, name: "James Wilson", role: "Student" },
        ],
        courses: [
            { id: 201, name: "Advanced Biochemistry", category: "Life Sciences" },
            { id: 202, name: "Venture Capital 101", category: "Business" },
        ]
    };

    const filteredResults = {
        schools: searchQuery ? mockResults.schools.filter(s => s.name.toLowerCase().includes(searchQuery.toLowerCase())) : [],
        users: searchQuery ? mockResults.users.filter(u => u.name.toLowerCase().includes(searchQuery.toLowerCase())) : [],
        courses: searchQuery ? mockResults.courses.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase())) : [],
    };

    const hasResults = filteredResults.schools.length > 0 || filteredResults.users.length > 0 || filteredResults.courses.length > 0;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowResults(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleResultClick = (path) => {
        navigate(path);
        setSearchQuery("");
        setShowResults(false);
    };

    return (
        <nav className="admin-topbar">
            <div className="admin-logo">
                <img src="/Vyudi-Logo.png" alt="Vyudi Logo" className="admin-logo-img" style={{ height: '32px', width: 'auto' }} />
            </div>

            <div className="admin-tb-r">
                <div className="admin-tb-search" ref={searchRef}>
                    <Search size={14} strokeWidth={2} />
                    <input
                        type="text"
                        placeholder="Search schools, users, courses…"
                        value={searchQuery}
                        onChange={(e) => {
                            setSearchQuery(e.target.value);
                            setShowResults(true);
                        }}
                        onFocus={() => setShowResults(true)}
                    />

                    {showResults && searchQuery && (
                        <div className="admin-search-results">
                            {hasResults ? (
                                <>
                                    {filteredResults.schools.length > 0 && (
                                        <div className="admin-search-section">
                                            <div className="admin-search-h">Schools</div>
                                            {filteredResults.schools.map(school => (
                                                <div key={school.id} className="admin-search-item" onClick={() => handleResultClick(`/admin/schools/${school.id}`)}>
                                                    <div className="admin-search-item-ic">
                                                        <School size={16} />
                                                    </div>
                                                    <div className="admin-search-item-info">
                                                        <span className="admin-search-item-t">{school.name}</span>
                                                        <span className="admin-search-item-d">{school.code}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {filteredResults.users.length > 0 && (
                                        <div className="admin-search-section">
                                            <div className="admin-search-h">Users</div>
                                            {filteredResults.users.map(u => (
                                                <div key={u.id} className="admin-search-item" onClick={() => handleResultClick(`/admin/users`)}>
                                                    <div className="admin-search-item-ic">
                                                        <User size={16} />
                                                    </div>
                                                    <div className="admin-search-item-info">
                                                        <span className="admin-search-item-t">{u.name}</span>
                                                        <span className="admin-search-item-d">{u.role}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {filteredResults.courses.length > 0 && (
                                        <div className="admin-search-section">
                                            <div className="admin-search-h">Courses</div>
                                            {filteredResults.courses.map(course => (
                                                <div key={course.id} className="admin-search-item" onClick={() => handleResultClick(`/admin/courses`)}>
                                                    <div className="admin-search-item-ic">
                                                        <Book size={16} />
                                                    </div>
                                                    <div className="admin-search-item-info">
                                                        <span className="admin-search-item-t">{course.name}</span>
                                                        <span className="admin-search-item-d">{course.category}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="admin-search-section" style={{ padding: '20px', textAlign: 'center', color: '#7D8B84', fontSize: '13px' }}>
                                    No matches found for "{searchQuery}"
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="admin-tb-notif">
                    <Bell size={14} strokeWidth={1.6} />
                </div>

                <div className="admin-tb-user-wrapper">
                    <div className="admin-tb-user" onClick={() => setShowDropdown(!showDropdown)}>
                        <div className="admin-tb-av">
                            {user?.nickname?.substring(0, 2).toUpperCase() || "AD"}
                        </div>
                        <div>
                            <div className="admin-tb-nm">{user?.name || "Aditi Devi"}</div>
                            <div className="admin-tb-rl">Super Admin</div>
                        </div>
                        <ChevronDown size={14} style={{ marginLeft: '4px', opacity: 0.5 }} />
                    </div>

                    {showDropdown && (
                        <div className="admin-tb-dropdown">
                            <div className="admin-dropdown-item" onClick={() => { navigate("/profile"); setShowDropdown(false); }}>
                                <span>Profile</span>
                            </div>
                            <div className="admin-dropdown-item logout" onClick={handleLogout}>
                                <span>Logout</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default AdminTopNav;
